export default __webpack_public_path__ + "static/feedback-0aa226db94c5e0e847b03470927cab73.webp";